import Vue from 'vue';
import Component from 'vue-class-component';
import {ProductSection, Product} from '../../models/ProductModels';
import {Viewport} from '../../models/Viewport';
import ProductLink from './ProductLink.vue';
import ProductLinkSoftbook from './ProductLinkSoftbook';



@Component({
name:"product-subsection",
props:{
    alprodentry:{

    },
    viewport:{

    }

},
components:{
    'product-link':ProductLink,
    'product-link-softbook':ProductLinkSoftbook
}
})

export default class  ProductAlphabeticalComponent extends Vue{
viewport:Viewport;
alprodentry:Object; 
isSoftbookLink:boolean=false;

get letter():string{ 
    //console.log('Mitten im LEben:', this.alprodentry);
    return this.alprodentry[0];
}

get productcIds(){

   //console.log('ALL- PRODUCTSIDS: ', this.alprodentry[1]);
    
return this.alprodentry[1];
}

created(){
    this.isSoftbookLink = this.viewport.viewportEvironment==='softbook';
    //console.log("PRODUCT- ALHPA: TEST:", this.alprodentry);
}
 
}